interface CardItem {
  title: string;
  category: string;
  description: string;
  rating: string;
  status: string;
  imageUrl: string;
}

const cards: CardItem[] = [
  {
    title: '恋爱百分百',
    category: '韩漫 · 恋爱',
    description: '契约婚姻开局，高冷总裁与元气少女的甜蜜拉扯，画风精致剧情高能，年度恋爱韩漫推荐榜首。',
    rating: '9.5',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20warm%20coral%20pink%20and%20cream%20gradient%2C%20soft%20romantic%20abstract%20shapes%2C%20no%20text%20no%20characters%2C%20elegant%20minimalist%20design%2C%20gentle%20flowing%20composition&width=400&height=520&seq=card-01&orientation=portrait',
  },
  {
    title: '妖怪公寓',
    category: '日漫 · 奇幻',
    description: '普通大学生意外入住妖怪公寓，与各路妖怪成为邻居的爆笑日常，温馨治愈又充满想象力。',
    rating: '9.3',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20amber%20golden%20and%20cream%20gradient%2C%20playful%20abstract%20geometric%20shapes%2C%20no%20text%20no%20characters%2C%20warm%20whimsical%20minimalist%20design&width=400&height=520&seq=card-02&orientation=portrait',
  },
  {
    title: '仙王的日常生活',
    category: '国漫 · 搞笑',
    description: '满级大佬伪装普通高中生的沙雕日常，笑点密集画风清新，国漫搞笑题材口碑之作，解压必备。',
    rating: '9.4',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20muted%20sage%20green%20and%20cream%20gradient%2C%20light%20playful%20abstract%20composition%2C%20no%20text%20no%20characters%2C%20fresh%20modern%20minimalist%20design&width=400&height=520&seq=card-03&orientation=portrait',
  },
  {
    title: '星界纹章',
    category: '国漫 · 科幻',
    description: '浩瀚星河中的文明碰撞，宏大世界观搭配精细画工，被誉为近年国漫科幻题材的里程碑之作。',
    rating: '9.2',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20deep%20coral%20and%20dark%20charcoal%20gradient%2C%20futuristic%20abstract%20geometric%20design%2C%20no%20text%20no%20characters%2C%20sleek%20cosmic%20minimalist%20aesthetic&width=400&height=520&seq=card-04&orientation=portrait',
  },
  {
    title: '花间辞',
    category: '国漫 · 古风',
    description: '古风仙侠恋爱物语，唯美水墨画风搭配虐心剧情。前世今生的宿命纠葛，每一帧都可以当壁纸。',
    rating: '9.6',
    status: '已完结',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20soft%20coral%20and%20cream%20gradient%2C%20elegant%20flowing%20ink%20wash%20abstract%20shapes%2C%20no%20text%20no%20characters%2C%20classical%20refined%20minimalist%20design&width=400&height=520&seq=card-05&orientation=portrait',
  },
  {
    title: '深渊凝视',
    category: '韩漫 · 恐怖',
    description: '心理恐怖类韩漫神作，巧妙的分镜设计和压抑氛围营造让人毛骨悚然，胆小慎入但绝对值得一看。',
    rating: '9.1',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20dark%20moody%20coral%20red%20and%20black%20gradient%2C%20ominous%20abstract%20shadow%20shapes%2C%20no%20text%20no%20characters%2C%20dark%20atmospheric%20minimalist%20design&width=400&height=520&seq=card-06&orientation=portrait',
  },
  {
    title: '武林神话',
    category: '国漫 · 热血',
    description: '少年习武闯荡江湖的热血史诗，打斗场面燃到爆炸，角色成长线饱满。国漫热血格斗类的标杆之作。',
    rating: '9.3',
    status: '连载中',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20with%20bold%20orange%20red%20and%20cream%20gradient%2C%20dynamic%20brushstroke%20abstract%20design%2C%20no%20text%20no%20characters%2C%20powerful%20energetic%20minimalist%20aesthetic&width=400&height=520&seq=card-07&orientation=portrait',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              编辑推荐
            </h2>
            <p className="text-sm text-foreground-600">编辑团队精选的高分漫画作品</p>
          </div>
          <a href="#index" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-bold">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                    item.status === '已完结' ? 'bg-secondary-500 text-background-50' : 'bg-primary-500 text-background-50'
                  }`}>
                    {item.status}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-primary-600 font-medium mb-1">{item.category}</p>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((item, idx) => (
            <a
              key={idx + 4}
              href="#carousel"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative flex-shrink-0 w-16 h-20 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute top-0 right-0 px-1.5 py-0.5 bg-accent-500 text-background-50 text-[10px] font-bold rounded-bl-md">
                  {item.rating}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-primary-600 font-medium">{item.category}</p>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}